import { DefaultFallbackComponent } from '@capturi/react-utils'
import { useOrganization } from '@capturi/stores'
import { Spinner } from '@capturi/ui-components'
import { FC } from 'react'
import { useGetCopilotConfig } from './api/useOrganizationSettings'
import { AgentCoPilotConfig } from './components/AgentCoPilotConfig'

export const AgentCoPilot: FC = () => {
  const { uid } = useOrganization()
  const {
    data: copilotConfig,
    isPending: isCopilotConfigPending,
    error: copilotConfigError,
  } = useGetCopilotConfig(uid)

  if (isCopilotConfigPending) {
    return <Spinner />
  }

  if (copilotConfigError) {
    return <DefaultFallbackComponent error={copilotConfigError} />
  }

  return <AgentCoPilotConfig copilotConfig={copilotConfig} orgUid={uid} />
}
